module.exports = __webpack_public_path__ + "img/SCC_Mast.d4126650.png";